import { Injectable } from "@angular/core";
import { GenericData, LocalData, UserConfig } from "src/app/models/local-data";
import { AgentModel, AgentView } from "src/app/modules/agent/models/agent";
import { AuthToken } from "src/app/modules/auth/models/auth.token";
import { AssessmentFilter, LessonDTO, LessonFilter, ReferenceContentDTO, TopicAndContent } from "src/app/modules/class/models/lesson.model";
import { InstituteView } from "src/app/modules/institute/models/institute-model";
import { environment } from "src/environments/environment";
import { EncoderService } from "./encoder-service";
import { AIBotDTO } from "src/app/modules/ai-tutor/models/ai-tutor.models";
import { StudentDetailsDTO, StudentRegistrationDTO } from "src/app/modules/student-management/models/student.model";

@Injectable({
  providedIn: 'root',
})
export class StorageHelper {

  private LOCAL_STORAGE_KEY = `L${environment.appVersion}-${environment.USERDATA_KEY}`;
  private GENERIC_STORAGE_KEY = `G${environment.appVersion}-${environment.USERDATA_KEY}`;
  private AGENT_STORAGE_KEY = `A${environment.appVersion}-${environment.USERDATA_KEY}`;
  private STUDENT_STORAGE_KEY = `S${environment.appVersion}-${environment.USERDATA_KEY}`;


  constructor(private _encoder: EncoderService) { }

  private fetchLocalStorageData = (): LocalData => {
    if (localStorage) {
      try {
        const lsValue: string | null = localStorage.getItem(this.LOCAL_STORAGE_KEY)
        if (lsValue) {
          //var jsontext = window.btoa(lsValue) as string;
          var form = JSON.parse(lsValue) as LocalData
          return form;
        }
      } catch (error) {
        console.error('LOCAL STORAGE PARSE ERROR', error)
      }
    }
    return new LocalData();
  }

  private updateLocalStorageData = (val: LocalData) => {
    if (!localStorage) {
      return
    }
    try {
      var jsonString = JSON.stringify(val);
      //var lsValue = window.atob(jsonString)
      localStorage.setItem(this.LOCAL_STORAGE_KEY, jsonString)
    } catch (error) {
      console.error('LOCAL STORAGE SAVE ERROR', error)
    }
  }

  private removeLocalStorageData = () => {
    if (!localStorage) {
      return
    }
    try {
      localStorage.removeItem(this.LOCAL_STORAGE_KEY)
    } catch (error) {
      console.error('LOCAL STORAGE REMOVE ERROR', error)
    }
  }

  private fetchGenericStorageData = (): GenericData => {
    if (localStorage) {
      try {
        const lsValue: string | null = localStorage.getItem(this.GENERIC_STORAGE_KEY)
        if (lsValue) {
          const decrypted = this._encoder.xorDecryptFromBase64(lsValue, this.GENERIC_STORAGE_KEY);
          var form = JSON.parse(decrypted) as GenericData
          return form;
        }
      } catch (error) {
        console.error('LOCAL STORAGE PARSE ERROR', error)
      }
    }
    return new GenericData();
  }

  private updateGenericStorageData = (val: GenericData) => {
    if (!localStorage) {
      return
    }
    try {
      var jsonString = JSON.stringify(val);
      const encrypted = this._encoder.xorEncryptToBase64(jsonString, this.GENERIC_STORAGE_KEY);
      console.log('updateGenericStorageData length : ' + encrypted.length);
      localStorage.setItem(this.GENERIC_STORAGE_KEY, encrypted)
    } catch (error) {
      console.error('LOCAL STORAGE SAVE ERROR', error)
    }
  }

  private removeGenericStorageData = () => {
    if (!localStorage) {
      return
    }
    try {
      localStorage.removeItem(this.GENERIC_STORAGE_KEY)
    } catch (error) {
      console.error('LOCAL STORAGE REMOVE ERROR', error)
    }
  }

  public deleteLocalStorageData(): void {
    this.removeLocalStorageData();
  }

  public deleteGenericStorageData(): void {
    this.removeGenericStorageData();
  }

  public setAuthToken(val: AuthToken): void {
    var old = this.fetchLocalStorageData();
    old.authToken = val;
    var expiry = new Date();
    expiry.setSeconds(expiry.getSeconds() + val.expires_in - 60)
    old.authTokenExpiry = expiry;
    this.updateLocalStorageData(old);
  }
  public getAuthToken(): AuthToken | undefined {
    return this.fetchLocalStorageData().authToken
  }
  public getAuthTokenExpiry(): Date {
    return this.fetchLocalStorageData().authTokenExpiry as Date
  }

  public setMessage(val: string | undefined): void {
    var old = this.fetchGenericStorageData();
    old.message = val;
    this.updateGenericStorageData(old);
  }
  public getMessage(): string | undefined {
    return this.fetchGenericStorageData().message
  }

  public deleteAgent(): void {
    if (!localStorage) {
      return
    }
    try {
      localStorage.removeItem(this.AGENT_STORAGE_KEY)
    } catch (error) {
      console.error('LOCAL STORAGE REMOVE ERROR', error)
    }
  }

  public setAgent(val: AgentModel | AgentView): void {
    if (!localStorage) {
      return
    }
    try {

      var agent = new AgentView();
      agent.agentID = val.agentID;
      agent.id = val.id;
      agent.brandName = val.brandName;
      agent.logoUrl = val.logoUrl;
      agent.altLogoUrl = val.altLogoUrl;
      agent.iconUrl = val.iconUrl;
      agent.altIconUrl = val.altIconUrl;
      agent.useAgentBranding = val.useAgentBranding;

      var jsonString = JSON.stringify(agent);
      console.log('updateAgentData length : ' + jsonString.length);
      localStorage.setItem(this.AGENT_STORAGE_KEY, jsonString)
    } catch (error) {
      console.error('LOCAL STORAGE SAVE ERROR', error)
    }
  }

  public getAgent(): AgentView {
    if (localStorage) {
      try {
        const lsValue: string | null = localStorage.getItem(this.AGENT_STORAGE_KEY)
        if (lsValue) {
          var form = JSON.parse(lsValue) as AgentView
          return form;
        }
      } catch (error) {
        console.error('LOCAL STORAGE PARSE ERROR', error)
      }
    }
    return new AgentView();
  }

  public setStudent(val: StudentRegistrationDTO): void {
    if (!localStorage) {
      return
    }
    try {
      var jsonString = JSON.stringify(val);
      console.log('updateAgentData length : ' + jsonString.length);
      localStorage.setItem(this.STUDENT_STORAGE_KEY, jsonString)
    } catch (error) {
      console.error('LOCAL STORAGE SAVE ERROR', error)
    }
  }

  public getStudent(): StudentDetailsDTO {
    if (localStorage) {
      try {
        const lsValue: string | null = localStorage.getItem(this.STUDENT_STORAGE_KEY)
        if (lsValue) {
          var form = JSON.parse(lsValue) as StudentDetailsDTO
          return form;
        }
      } catch (error) {
        console.error('LOCAL STORAGE PARSE ERROR', error)
      }
    }
    return new StudentDetailsDTO();
  }

  public setMyLesson(val?: LessonDTO): void {
    var old = this.fetchGenericStorageData();
    old.lesson = val;
    this.updateGenericStorageData(old);
  }
  public getMyLesson(): LessonDTO {
    return this.fetchGenericStorageData().lesson!;
  }
  public setReferenceContent(val: Array<ReferenceContentDTO>): void {
    var old = this.fetchGenericStorageData();
    old.refContent = val;
    this.updateGenericStorageData(old);
  }
  public getReferenceContent(): Array<ReferenceContentDTO> {
    return this.fetchGenericStorageData().refContent ?? [];
  }
  public setMyLessonFilter(val: LessonFilter): void {
    var old = this.fetchGenericStorageData();
    old.lessonFilter = val;
    this.updateGenericStorageData(old);
  }
  public getMyLessonFilter(): LessonFilter {
    return this.fetchGenericStorageData().lessonFilter ?? new LessonFilter();
  }
  public setUserConfig(val: UserConfig): void {
    var old = this.fetchGenericStorageData();
    old.userConfig = val;
    this.updateGenericStorageData(old);
  }
  public getUserConfig(): UserConfig {
    return this.fetchGenericStorageData().userConfig ?? new UserConfig();
  }
  public setAssessmentFilter(val: AssessmentFilter): void {
    var old = this.fetchGenericStorageData();
    old.assessmentFilter = val;
    this.updateGenericStorageData(old);
  }
  public getAssessmentFilter(): AssessmentFilter {
    return this.fetchGenericStorageData().assessmentFilter ?? new AssessmentFilter();
  }
  public setInstituteView(val?: InstituteView): void {
    var old = this.fetchGenericStorageData();
    old.instituteView = val;
    this.updateGenericStorageData(old);
  }
  public getInstituteView(): InstituteView | undefined {
    return this.fetchGenericStorageData().instituteView;
  }
  public setAIConfig(val?: AIBotDTO): void {
    var old = this.fetchGenericStorageData();
    old.aiConfig = val;
    this.updateGenericStorageData(old);
  }
  public getAIConfig(): AIBotDTO | undefined {
    return this.fetchGenericStorageData().aiConfig;
  }
};

